/* eslint-disable no-undef, no-unused-vars */
import { makeAutoObservable } from "mobx";
import ApplicationStore from "./ApplicationStore";

export type Step = {
  key: number;
  title: string;
};

class StepByStepTabStore {
  private _appStore: ApplicationStore;
  errorMessage: string = "";
  isError: boolean = false;
  currentStep: number = 1;
  activeTabsList: number[] = [1];
  stepList: Step[] = [
    { key: 1, title: "Communication Type" },
    { key: 2, title: "Document Upload" },
    { key: 3, title: "Recipients" },
    { key: 4, title: "Options" },
    { key: 5, title: "Send" },
  ];

  constructor(appStore: ApplicationStore) {
    makeAutoObservable(this);
    this._appStore = appStore;
  }

  private _validation(prev?: boolean): boolean {
    if (this.currentStep === 1) {
      if (!this._appStore.communicationType.comTypeId) {
        this.errorMessage =
          "You haven't selected a communication type. Choose it and keep working!";
        this.isError = true;
        return false;
      }
    } else if (this.currentStep === 2) {
      if (prev) {
        if (this._appStore.mailJob.files?.length > 0) {
          this.errorMessage =
            "Delete all attached documents before changing Communication Type.";
          this.isError = true;
          return false;
        }
      } else {
        if (
          !this._appStore.mailJob.files ||
          this._appStore.mailJob.files?.length === 0
        ) {
          this.errorMessage = "Please add a document.";
          this.isError = true;
          return false;
        }
      }
      if (this._appStore.mailJob.files) {
        if (this._appStore.communicationType.comTypeId === 1) {
          if (
            !this._appStore.mailJob.files.every(
              (_) => _.fileInfo.communityKey !== undefined
            )
          ) {
            this.errorMessage = "Select Property for them.";
            this.isError = true;
            return false;
          } else if (
            !this._appStore.mailJob.files.every(
              (_) =>
                _.fileInfo.communityKey ===
                this._appStore.mailJob.files![0].fileInfo.communityKey
            )
          ) {
            this.errorMessage =
              "Multiple properties are selected. Please select one Property for all documents being uploaded.";
            this.isError = true;
            return false;
          }
        } else {
          if (
            !this._appStore.mailJob.files.every(
              (_) => _.fileInfo.account !== undefined
            )
          ) {
            this.errorMessage = "Select Property and Account number for them.";
            this.isError = true;
            return false;
          }
        }
      }
    }

    return true;
  }

  clearError(): void {
    this.errorMessage = "";
    this.isError = false;
  }

  next(): void {
    if (this._validation()) {
      if (!this.activeTabsList.includes(this.currentStep + 1)) {
        this.activeTabsList = [...this.activeTabsList, this.currentStep + 1];
      }
      this.currentStep++;
    }
  }

  prev(): void {
    if (this._validation(true)) {
      this.currentStep--;
    }
  }

  setActiveTabs(): void {
    if (this._appStore.mailJob?.files?.length > 0) {
      const newTabsActive: number[] = [];
      const removeTabsActive: number[] = [1];

      if (this._appStore.communicationType.comTypeId === 1) {
        if (
          !this._appStore.mailJob.files.every(
            (_) => _.fileInfo.communityKey !== undefined
          )
        ) {
          removeTabsActive.push(...[3, 4, 5]);
        } else if (
          !this._appStore.mailJob.files.every(
            (_) =>
              _.fileInfo.communityKey ===
              this._appStore.mailJob.files![0].fileInfo.communityKey
          )
        ) {
          removeTabsActive.push(...[3, 4, 5]);
        }
      } else {
        if (
          !this._appStore.mailJob.files.every(
            (_) => _.fileInfo.account !== undefined
          )
        ) {
          removeTabsActive.push(...[3, 4, 5]);
        }
      }
      this.activeTabsList.forEach((_) => {
        if (!removeTabsActive.includes(_)) {
          newTabsActive.push(_);
        }
      });
      this.activeTabsList = newTabsActive;
    } else {
      if (this.currentStep > 1) {
        this.activeTabsList = [1, 2];
        this.currentStep = 2;
      } else {
        this.activeTabsList = [1];
      }
    }
  }

  setTab(key: number): void {
    if (this.stepList.map((_) => _.key).includes(key)) {
      this.currentStep = key;
    }
  }
}
export default StepByStepTabStore;
